import { render, staticRenderFns } from "./HeaderService.vue?vue&type=template&id=6c74abae&scoped=true"
import script from "./HeaderService.vue?vue&type=script&lang=js"
export * from "./HeaderService.vue?vue&type=script&lang=js"
import style0 from "./HeaderService.vue?vue&type=style&index=0&id=6c74abae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c74abae",
  null
  
)

export default component.exports